/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfDataSourceResultDtoOfAppDto } from '../../models/platform-api-result-of-data-source-result-dto-of-app-dto';
import { PlatformDataSourceQuery } from '../../models/platform-data-source-query';

export interface PostAppsQueryDatasource$Params {
      body: PlatformDataSourceQuery
}

export function postAppsQueryDatasource(http: HttpClient, rootUrl: string, params: PostAppsQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfAppDto>> {
  const rb = new RequestBuilder(rootUrl, postAppsQueryDatasource.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfAppDto>;
    })
  );
}

postAppsQueryDatasource.PATH = '/api/apps/query/datasource';
